var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-custom"},[(_vm.isMessageRating(_vm.props.message))?_c('MessageRating',{attrs:{"message":_vm.props.message},on:{"sendMessage":_vm.sendCustomMessage}}):(_vm.isCustomerServiceMessage(_vm.props.message))?_c('MessageCustomerService',{attrs:{"message":_vm.props.message},on:{"sendMessage":_vm.sendTextMessage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }